import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { canAddToCart } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import Typography from "@insite/mobius/Typography";
import * as React from "react";
import { connect } from "react-redux";
import styled from "styled-components";

type OwnProps = WidgetProps & HasProductContext & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState,  props: HasProductContext) => ({
    productSettings: getSettingsCollection(state).productSettings,
    canAddToCart: canAddToCart(
        state,
        props.productContext.product,
        props.productContext.productInfo,
        state.pages.productDetails.configurationCompleted,
        state.pages.productDetails.variantSelectionCompleted,
    ),
    userRoles: state.context.session!.userRoles,
    isAuthenticated: state.context.session!.isAuthenticated,
});

export interface ProductDetailsPriceStyles {
    productPrice?: ProductPriceStyles;
}

export const priceStyles: ProductDetailsPriceStyles = {
    productPrice: {
        price: {
            priceText: { size: 32, weight: 400 },
            unitOfMeasureText: { size: 32 },
        },
    },
};

const styles = priceStyles;

const Container = styled.div`
    margin: 12px 0px;
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    > * {
        display: inline-flex;
        width: auto;
    }
`;

const ProductDetailsPrice: React.FC<OwnProps> = ({ productContext, productSettings, canAddToCart, userRoles, isAuthenticated }) => {
    return productSettings.canAddToCart && canAddToCart && isAuthenticated && userRoles.toLowerCase().includes("vip") ? (
        <Container>
            <ProductPrice
                product={productContext}
                showLabel={false}
                showSavings={false}
                showUnitOfMeasure={false}
                currencySymbol=""
                showSavingsAmount={productSettings.showSavingsAmount}
                showSavingsPercent={productSettings.showSavingsPercent}
                extendedStyles={styles.productPrice}
            />
            <Typography size="32px" weight={200}>
                CAD/{productContext.productInfo.unitOfMeasure}
            </Typography>
            {/* <Typography size="12px" weight={600} style={{width: "115px"}}>TO BE CONFIRMED AT CHECKOUT</Typography> */}
        </Container>
    ) : null;
};

const widgetModule: WidgetModule = {
    component: withProductContext(connect(mapStateToProps)(ProductDetailsPrice)),
    definition: {
        displayName: "Price",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
